module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "imagec",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0018-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "imagep"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0020-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _vm._v("Breakfast is one of two things for me: grab-and-go fuel for sustenance before I go surfing or do a kick-butt workout, or a leisurely “Let’s prolong the start of the day so we don’t really have to get anything accomplished” type of meal. I’m fine with the former, but if I have my druthers, I prefer the latter. My friends and I call this kind of breakfast “cawfee tawk,” and we sit around and gossip, pontificate, and beat the events of the prior night to death. I put on an extra-large pot of coffee and make a simple breakfast. I have no interest in being a short-order cook—I want to be part of the fun!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My friend Marcy Blum is the queen of cawfee tawk. Marcy is an event planner extraordinaire, and boy does she have interesting insights on just about everything. I’ll wake up before she does and bang around the kitchen trying to make enough noise to “accidentally” wake her from slumber. It is always the same routine: I hear her schlump down the stairs, she walks into the kitchen, hair in every direction and last night’s mascara under her eyes, and she says, “What’s wrong with you people, why are you so awake and chipper?” Then she proceeds to make everyone laugh with her ever-witty commentary. Marcy, this chapter’s for you.")]), _vm._v(" "), _c('p', {
    staticClass: "imageb"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0023-01.jpg"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "h3p",
    attrs: {
      "id": "res_1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _vm._v("nectarine and cream cheese french toast sandwiches")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Stone fruits are at their peak in July and August. I am constantly stopping at a favorite farm stand, the Green Thumb, to pick up peaches, plums, apricots, and nectarines. Most often, I enjoy them immediately, leaning over the kitchen sink, juice dripping off my chin as I sink my teeth into their sweet flesh, but occasionally they make it to the next morning and find their way into a French toast sandwich.")]), _vm._v(" "), _c('p', {
    staticClass: "serve"
  }, [_vm._v("MAKES 4 SANDWICHES")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("3 tablespoons salted butter")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("2 nectarines, cut in half, pits removed, and thinly sliced")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("8 (¼-inch/6-mm) slices challah or brioche")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("6 tablespoons (85 g) cream cheese")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("4 large eggs")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("¼ cup (60 ml) milk")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("2 tablespoons granulated sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("1 teaspoon vanilla extract")])]), _vm._v(" "), _c('p', {
    staticClass: "inga"
  }, [_c('strong', [_vm._v("Confectioners’ sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("In a small skillet, melt 1 tablespoon of the butter over medium heat. Add the nectarines and cook for 4 to 5 minutes, until softened. Remove from the heat.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Spread each slice of bread with cream cheese. Divide the nectarines evenly among four slices of bread and top with the remaining bread to build sandwiches.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("In a shallow dish, whisk the eggs, milk, sugar, and vanilla together. Carefully dip the sandwiches into the egg mixture and turn to coat.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Melt the remaining 2 tablespoons butter on a griddle over medium heat. Cook the sandwiches for 2 to 3 minutes per side, until golden brown. Dust with confectioners’ sugar and serve.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0022-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "imagep"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0024-01.jpg"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "h3ps",
    attrs: {
      "id": "res_2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _vm._v("grilled doughnuts with melted nutella")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It’s pretty darn difficult to improve on a doughnut, but if they’ve sat around one day too long and you need to breathe some life back into them, just pop them in a panini press. In just a few minutes, they’ll be warm and crunchy on the outside and tender inside.")]), _vm._v(" "), _c('p', {
    staticClass: "serve"
  }, [_vm._v("MAKES 4 DOUGHNUTS")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("4 cinnamon sugar doughnuts")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("¼ cup (60 g) Nutella")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Preheat a panini press to medium-high. Place the doughnuts inside and cook for 2 to 3 minutes. (If you don’t have a panini press, you can use a grill pan and place a weight on top of the doughnuts to press them down.) Meanwhile, microwave the Nutella until melted, about 40 seconds. While the doughnuts are still warm, use a spoon to drizzle melted Nutella over the tops. Serve the doughnuts with the Nutella for dipping.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _c('h3', {
    staticClass: "h3ps",
    attrs: {
      "id": "res_3"
    }
  }, [_vm._v("grilled doughnuts with ricotta and honey")]), _vm._v(" "), _c('p', {
    staticClass: "serve"
  }, [_vm._v("MAKES 4 DOUGHNUTS")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("4 yeast doughnuts")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("¼ cup (60 g) ricotta cheese")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("1 tablespoon honey")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Preheat a panini press to medium-high. Place the doughnuts inside and cook for 2 to 3 minutes. (If you don’t have a panini press, you can use a grill pan and place a weight on top of the doughnuts to press them down.) Meanwhile, whisk the ricotta and honey in a small bowl. Serve with the doughnuts as a spread.")]), _vm._v(" "), _c('p', {
    staticClass: "imageb"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0026-01.jpg"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "h3p",
    attrs: {
      "id": "res_4"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _vm._v("breakfast bread")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Breakfast bread is kind of like a pizza with eggs on it. Like 99.9 percent of the population, I like shortcuts in the morning, so I make this using store-bought naan (an Indian bread) instead of making homemade. Everything goes right on the naan and gets baked to perfection. I like the eggs kind of runny, so that when you cut into the bread the yolk oozes out and creates a rich sauce as it mixes with the hot ricotta and melted Gruyère.")]), _vm._v(" "), _c('p', {
    staticClass: "serve"
  }, [_vm._v("MAKES 4 PIECES")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("1 (8.8-ounce/246-g) package (4 pieces) naan bread (I like Stonefire brand)")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("½ cup (120 g) ricotta")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("4 eggs")])]), _vm._v(" "), _c('p', {
    staticClass: "inga"
  }, [_c('strong', [_vm._v("Flaky sea salt (I like Maldon) and freshly ground black pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("8 slices prosciutto")])]), _vm._v(" "), _c('p', {
    staticClass: "inga"
  }, [_c('strong', [_vm._v("Handful of cherry tomatoes, halved")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("½ cup (60 g) grated Gruyère cheese")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("2 scallions, white and light green parts only, thinly sliced")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Preheat the oven to 400°F (205°C). Spray a baking sheet with nonstick cooking spray.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Spread 2 tablespoons of the ricotta evenly onto each naan. Carefully crack the eggs onto the ricotta, 1 egg per naan. Sprinkle with sea salt and pepper. Place 2 slices of prosciutto around each egg, scatter with the tomatoes, and top with the Gruyère and scallions.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Bake until the eggs are set, 10 to 15 minutes, depending on how well you like to cook your egg yolks. Serve hot.")]), _vm._v(" "), _c('p', {
    staticClass: "imageb"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0029-01.jpg"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "h3p",
    attrs: {
      "id": "res_5"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _vm._v("huevos rancheros")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I first started making these a couple of years ago when I had houseguests. I was up early piddling around while everyone else was still sleeping (as per usual), and I wanted to cook something different for breakfast. I had just bought these new individual baking dishes and was itching to use them, so I made up this recipe for huevos rancheros. It was a hit and quickly became part of my repertoire.")]), _vm._v(" "), _c('p', {
    staticClass: "serve"
  }, [_vm._v("SERVES 4")]), _vm._v(" "), _c('p', {
    staticClass: "inga"
  }, [_c('strong', [_vm._v("Olive oil")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("1 onion, diced")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("1 red bell pepper, cored and diced")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("1 serrano chile, diced")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("2 cloves garlic, minced")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("1 teaspoon dried oregano")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("1 (28-ounce/793-g) can crushed tomatoes")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("1 (15-ounce/425-g) can black beans, drained and rinsed")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("¼ cup (25 g) chopped fresh cilantro, plus more for garnish")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("8 eggs")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("1 cup (120 g) grated Monterey Jack–cheddar cheese blend")])]), _vm._v(" "), _c('p', {
    staticClass: "inga"
  }, [_c('strong', [_vm._v("Sour cream")])]), _vm._v(" "), _c('p', {
    staticClass: "inga"
  }, [_c('strong', [_vm._v("Guacamole")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Preheat the oven to 350°F (175°C).")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("In a medium skillet, heat the oil over medium heat. Add the onion and sauté until tender, about 5 to 7 minutes. Add the bell pepper, then the chile. Add the garlic. Stir in the oregano, tomatoes, and beans and bring to a simmer, about 5 minutes. Reduce the heat, cover, and cook for 10 minutes. Add the ¼ cup cilantro and stir.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Ladle into 4 individual-serving-size baking dishes. Crack 2 eggs into each dish and sprinkle with the cheese. Bake for 15 minutes, or until the eggs are set to your liking. Sprinkle with cilantro and serve hot with sour cream and guacamole.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3p",
    attrs: {
      "id": "res_6"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _vm._v("triple coconut waffles")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Coconut is all the rage in healthy eating, and luckily it tastes good too. I make these waffles with coconut milk, coconut oil, and shredded coconut for a triple threat. They are yummy for breakfast, but save some so you have leftovers to serve later for dessert with vanilla ice cream and a little hot fudge.")]), _vm._v(" "), _c('p', {
    staticClass: "serve"
  }, [_vm._v("MAKES 8 WAFFLES")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("2 large eggs, separated")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("½ cup (120 ml) coconut oil, melted and cooled")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("2 cups (480 ml) light coconut milk")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("1 ⅔ cup (200 g) white spelt or all-purpose flour")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("¼ cup (25 g) unsweetened shredded coconut")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("⅓ cup (45 g) cornstarch")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("2 teaspoons baking powder")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("½ teaspoon salt")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("2 tablespoons sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "inga"
  }, [_c('strong', [_vm._v("Maple syrup")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Preheat a waffle iron.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("In a medium bowl, whisk the egg yolks with the oil to create an emulsion. Whisk in the coconut milk.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("In another bowl, whisk together the flour, coconut, cornstarch, baking powder, and salt. Add to the egg mixture and stir until combined.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Using a handheld electric mixer, in a third bowl, whisk the egg whites with the sugar until firm soft peaks form.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Gently fold the egg whites into the batter until just combined; do not overmix.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Working in batches, make waffles in the waffle iron according to the manufacturer’s instructions. (I use about ½ cup/120 ml batter for each waffle and cook them for about 4 minutes.) To keep your waffles warm until serving time, place them on a baking sheet in an oven preheated to 200°F (100°C) as they are made. Serve hot with maple syrup.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3p",
    attrs: {
      "id": "res_7"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _vm._v("smoothies")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Smoothie time! A few years ago I invested in a Vitamix blender. I love the thing. I make smoothies quite often, and I love to pack them with flavorful, healthy ingredients. These are a few of my go-to combinations. You can follow the recipes exactly, or adapt them to your taste.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _c('h3', {
    staticClass: "h3ps"
  }, [_vm._v("yellow smoothie")]), _vm._v(" "), _c('p', {
    staticClass: "serve"
  }, [_vm._v("MAKES ABOUT 4 CUPS (960 ML); SERVES 2")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("2 ripe bananas")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("1 cup (165 g) frozen-mango chunks")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("½ cup (120 ml) plain or vanilla low-fat yogurt")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("2 tablespoons honey")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("2 teaspoons flax seeds")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("1 teaspoon ground turmeric")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("½ teaspoon ground ginger")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Put the bananas, mango, yogurt, honey, flax seeds, turmeric, and ginger in a blender and puree until smooth. Serve immediately.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _c('h3', {
    staticClass: "h3ps"
  }, [_vm._v("green smoothie")]), _vm._v(" "), _c('p', {
    staticClass: "serve"
  }, [_vm._v("MAKES ABOUT 3 CUPS (720 ML); SERVES 2")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("1 Granny Smith apple, cored and coarsely chopped")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("2 kiwi fruit, peeled and coarsely chopped")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("1 cup (30 g) packed baby spinach leaves")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("1 cup (240 ml) unsweetened almond milk")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("½ cup (120 ml) plain low-fat yogurt")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("1 tablespoon honey")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("1 teaspoon matcha (fine green tea) powder")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Put the apple, kiwi, spinach, almond milk, yogurt, honey, and matcha powder in a blender and puree until smooth. Serve immediately.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _c('h3', {
    staticClass: "h3ps"
  }, [_vm._v("red smoothie")]), _vm._v(" "), _c('p', {
    staticClass: "serve"
  }, [_vm._v("MAKES ABOUT 3 ½ CUPS (840 ML); SERVES 2")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("2 cups (300 g) frozen strawberries")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("1 cup (140 g) frozen raspberries")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("1 cup (240 ml) plain low-fat yogurt")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("1 cup (240 ml) unsweetened almond milk")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("1 tablespoon chia seeds")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("1 teaspoon honey")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Put the strawberries, raspberries, yogurt, almond milk, chia seeds, and honey in a blender and puree until very smooth. Serve immediately.")]), _vm._v(" "), _c('p', {
    staticClass: "imageb"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0032-01.jpg"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "h3p",
    attrs: {
      "id": "res_8"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _vm._v("strawberry kiwi quinoa breakfast parfait")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("These breakfast parfaits look so pretty and colorful and are so tasty, you’d never know they’re also super healthy. The Greek yogurt is packed with protein, the quinoa is also high in protein and has double the amount of fiber of most grains, and the strawberries and kiwi are both high in vitamin C and antioxidants. What a way to start the day!")]), _vm._v(" "), _c('p', {
    staticClass: "serve"
  }, [_vm._v("SERVES 4")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("2 cups (480 ml) plain Greek yogurt (I use 2%, but you can use any kind you like)")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("1 tablespoon honey")])]), _vm._v(" "), _c('p', {
    staticClass: "inga"
  }, [_c('strong', [_vm._v("Finely grated zest of ½ lime")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("1 cup (185 g) cooked quinoa, cooled")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("8 large strawberries, diced")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("2 kiwi fruit, peeled and diced")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("In a small bowl, whisk together the yogurt, honey, and lime zest.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Place 4 small (6-ounce/180-ml) juice glasses on a work surface and put 2 tablespoons of the quinoa in the bottom of each glass. Add ¼ cup (60 ml) of the yogurt to each glass, followed by about 2 tablespoons of the diced strawberries and kiwi. Repeat the layering in each glass, and scatter any additional fruit that is left over the top layer of yogurt. Serve immediately.")]), _vm._v(" "), _c('p', {
    staticClass: "imageb"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0035-01.jpg"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "h3p",
    attrs: {
      "id": "res_9"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _vm._v("rolled shrimp, goat cheese, and dill omelet")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("On "), _c('em', [_vm._v("The Kitchen")]), _vm._v(", I do a regular segment called “Leftover L’Oven,” where I take leftovers and transform them into a totally new dish. I like to think of it as giving leftovers a “makeover,” kind of like on those morning shows when they pluck an unsuspecting woman from the crowd, do her hair, put makeup on her, and—poof—she suddenly has a new look. In this recipe, I was inspired by leftover shrimp cocktail. The next day, I don’t really want to eat shrimp cocktail straight from the fridge. So why not put it in an omelet? And in order to avoid making individual omelets for everyone in the house, why not make one big omelet?")]), _vm._v(" "), _c('p', {
    staticClass: "serve"
  }, [_vm._v("SERVES 4")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("8 large eggs")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("½ cup (120 ml) whole milk")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("¼ cup (30 g) all-purpose flour")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("2 teaspoons dry ground mustard powder")])]), _vm._v(" "), _c('p', {
    staticClass: "inga"
  }, [_c('strong', [_vm._v("Finely grated zest of 1 lemon")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("¼ cup (25 g) chopped fresh dill, plus more for garnish")])]), _vm._v(" "), _c('p', {
    staticClass: "inga"
  }, [_c('strong', [_vm._v("Salt and freshly ground black pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("6 ounces (170 g) chopped cooked shrimp (about 1 ½ cups)")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("2 ounces (55 g) feta or fresh goat cheese, crumbled")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Preheat the oven to 350°F (175°C). Brush a high-sided jellyroll pan (10 ½ by 15 ½ inches/26.5 by 39 cm) with vegetable oil. Line the pan with parchment paper, cutting the paper larger than the pan so that it hangs over the pan edges by at least 1 inch (2.5 cm).")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("In a large bowl, whisk the eggs until blended. In a small bowl, whisk the milk, flour, mustard, and lemon zest until smooth; whisk into the eggs. Add the dill, season well with salt and pepper, and whisk until combined. Pour into the prepared pan.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Evenly scatter the shrimp and cheese over the top of the egg mixture. Bake until the eggs are completely set, 18 to 20 minutes. Remove from the oven and let stand for a couple of minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Starting at one of the shorter ends, roll up the omelet, peeling back the parchment paper. Lift the omelet out of the pan and transfer it to a large cutting board or serving platter. Cut the omelet into ½-inch (12-mm) slices, garnish each with a sprinkling of dill, and serve warm or at room temperature.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3p",
    attrs: {
      "id": "res_10"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _vm._v("chilaquiles frittata")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Chilaquiles is a traditional Mexican dish made from corn tortillas that are cut into strips, fried, and then simmered in salsa. They are often eaten for breakfast with eggs. One morning I found myself blankly staring at the pantry (if it had been a cartoon, there would have been a cloud above my head with a great big question mark), and then it hit me: a bag of slightly stale tortilla chips. Eureka! (Question mark now changes to lightbulb in the imaginary cartoon.) I’ll make a frittata with the chips to shortcut my way to a chilaquiles breakfast. (While eating, all my guests’ bubbles revealed an exclamation point!)")]), _vm._v(" "), _c('p', {
    staticClass: "serve"
  }, [_vm._v("SERVES 8")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("10 large eggs")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("2 cups (170 g) crushed tortilla chips")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("¼ cup (25 g) chopped fresh cilantro")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("¼ teaspoon salt")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("¼ teaspoon freshly ground black pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("1 tablespoon olive oil")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("8 scallions, white parts only, thinly sliced")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("1 serrano chile, minced")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("1 cup (180 g) chopped tomatoes")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("1 cup (165 g) corn kernels (cut from the cob or thawed if frozen)")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("1 (4-ounce/113-g) can diced green chiles")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("1 cup (120 g) grated Monterey Jack–cheddar cheese blend")])]), _vm._v(" "), _c('p', {
    staticClass: "inga"
  }, [_c('strong', [_vm._v("Sour cream")])]), _vm._v(" "), _c('p', {
    staticClass: "inga"
  }, [_c('strong', [_vm._v("Salsa")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Preheat the oven to 300°F (150°C).")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("In a large bowl, whisk the eggs. Add the tortilla chips, cilantro, salt, and pepper. Set aside.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Heat the oil in a large ovenproof nonstick skillet over medium-high heat. Add the scallions and serrano chile and sauté until softened, about 2 minutes. Add the tomatoes, corn, and green chiles and cook for about 3 minutes, until the corn is cooked through and the tomatoes have softened. Pour the egg mixture into the pan and top with the cheese.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Transfer to the oven and bake for 20 minutes, or until lightly browned and fluffy. (Note that the temperature is low, and this recipe cooks longer than a typical frittata; I find that cooking eggs low and slow results in better flavor and texture.) Cut into wedges and serve with sour cream and salsa.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3p",
    attrs: {
      "id": "res_11"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }), _vm._v("healthy banana oat muffins")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I like to start the day off healthy with muffins like these. I much prefer spelt flour to whole-wheat flour when baking, as it can be substituted cup-for-cup for regular all-purpose flour. You can feel good about all of the ingredients in these muffins. In the fall, try using mashed pumpkin instead of banana for a different spin.")]), _vm._v(" "), _c('p', {
    staticClass: "serve"
  }, [_vm._v("MAKES 12 MUFFINS")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("2 cups (240 g) spelt flour")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("2 teaspoons baking powder")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("½ teaspoon baking soda")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("1 teaspoon ground cinnamon")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("¾ teaspoon salt")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("⅓ cup (27 g) rolled oats, plus 2 tablespoons for sprinkling")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("1 cup (260 g) mashed ripe bananas (about 3 bananas)")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("1 ½ teaspoons fresh lemon juice")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("½ cup (120 ml) plain Greek yogurt (I use 2%, but you can use full-fat if you like)")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("2 large eggs, lightly beaten")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("½ cup (120 ml) maple syrup")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("¼ cup (60 ml) coconut oil, melted and cooled")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("2 teaspoons vanilla extract")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Preheat the oven to 350°F (175°C). Place paper liners in a 12-cup muffin pan and spray with nonstick cooking spray.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Sift the flour, baking powder, baking soda, cinnamon, and salt into a medium bowl. Stir in the oats.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("In a large bowl, whisk the bananas, lemon juice, yogurt, eggs, maple syrup, coconut oil, and vanilla together. Stir in the dry ingredients and mix until just combined; do not overmix! Use an ice cream scoop to evenly distribute the batter into the prepared pan. Sprinkle the tops with oats.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Bake for about 25 minutes, until the tops are golden brown and a toothpick inserted in the center of a muffin comes out clean. Let cool on a wire rack for a few minutes before removing from the tin.")]), _vm._v(" "), _c('p', {
    staticClass: "imageb"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0039-01.jpg"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "h3p",
    attrs: {
      "id": "res_12"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _vm._v("blender pancakes")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("You will never look at pancakes the same way again. It truly doesn’t get any easier than this. Pancakes on a weekday before work or getting the kids off to school? No problem! They can be done in about five minutes. They are healthy, full of fiber and protein, and you can give them more of a boost by adding some flax seeds or chia seeds. I’ve found that if I use Greek yogurt instead of cottage cheese, I sometimes need to add a tiny splash of milk to the batter; yogurt will also make for a slightly denser, more protein-rich pancake.")]), _vm._v(" "), _c('p', {
    staticClass: "serve"
  }, [_vm._v("MAKES 4 – 6 MEDIUM-SIZED PANCAKES")]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("1 cup (240 ml) cottage cheese or Greek yogurt")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("2 large eggs")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('strong', [_vm._v("1 cup (80 g) rolled oats")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Preheat a griddle over medium-high heat.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Put the cottage cheese, eggs, and oats in a blender and blend until smooth.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Spray the griddle with nonstick cooking spray. Pour the batter from the blender onto the griddle to make your desired size of pancakes. Cook until bubbles start to form on the surface of the pancakes about 1 to 1 ½ minutes. Flip and cook for 1 minute more. Serve with maple syrup, butter, jam, whatever you like!")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c53c630","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01.vue
// module id = 75
// module chunks = 0